import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appZipcodeMask]'
})
export class ZipcodeMaskDirective {
  private previousValue: string = '';

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
    onInput(event: Event): void {
      const input = event.target as HTMLInputElement;
      let value = input.value.replace(/[^\d-]/g, '');

      // Remove extra hyphens
      value = value.replace(/-+/g, '-');

      // Enforce mask: XXXXX or XXXXX-XXXX
      if (value.length > 5) {
        value = value.slice(0, 5) + '-' + value.slice(5);
      }
      // Only allow up to 5 digits before hyphen and 4 after
      const match = value.match(/^(\d{0,5})(-(\d{0,4}))?/);
      if (match) {
        value = match[1] + (match[2] ? match[2] : '');
      }
      // Remove any extra characters beyond XXXXX-XXXX
      value = value.slice(0, 10);

      // Validate against the mask
      const maskRegex = /^\d{0,5}(-\d{0,4})?$/;
      if (!maskRegex.test(value)) {
        value = this.previousValue;
      }
      input.value = value;
      this.previousValue = value;
    }
}
